class ProgramSlider {
    constructor(element) {
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.slider = element.querySelector('.slider-wrapper');
        this.prevArrow = element.querySelector('.slick-slider-arrow-prev') ?? undefined;
        this.nextArrow = element.querySelector('.slick-slider-arrow-next') ?? undefined;
        if (this.slider) {
            jQuery(this.slider).slick({
                fade: true,
                dots: true,
                prevArrow: this.prevArrow,
                nextArrow: this.nextArrow,
                rows: 0,
            });
        }
    }
}
export default function programSlider() {
    const programSliders = document.querySelectorAll('.program-slider');
    for (const element of programSliders) {
        new ProgramSlider(element);
    }
}
